import EventEmitter from "eventemitter2";
import ScreenShareApis, {
  NotifyEvent,
  RecordStatus,
  StartAudioMixRecordConfig,
  MicrophoneInfo,
} from "./fetch";

export type { StartAudioMixRecordConfig, MicrophoneInfo };

export class LocalLinkRecorder extends EventEmitter {
  private _recording: boolean;
  private _currentConfig: StartAudioMixRecordConfig | null;
  private _recordStatusUnsubscribe: (() => void) | null;
  private _recordDataUnsubscribe: (() => void) | null;
  constructor() {
    super();
    this._recording = false;
    this._currentConfig = null;
    this._recordStatusUnsubscribe = null;
    this._recordDataUnsubscribe = null;
  }

  public get type() {
    return "localLink";
  }

  public getpermission = async () => {
    // TODO: 获取权限
    return true;
  };

  /**
   * 开始本地录制
   * @param info
   * @returns
   */
  public start = async (info: StartAudioMixRecordConfig) => {
    try {
      // 注册各种回调
      this._recordStatusUnsubscribe = ScreenShareApis.onLocalRecordStatus(
        this._handleRecordStatus
      );
      // 开始录制
      console.log('start localLink', info)
      const res = await ScreenShareApis.startLocalRecord(info);
      this._recordDataUnsubscribe = ScreenShareApis.onLocalRecordData(
        this._handleRecordData
      );
      if (res.code !== 0) {
        throw new Error(res.msg);
      }
      this._recording = true;
      this._currentConfig = info;
    } catch (error) {
      console.log("启动本地录制失败", error);
      // 清除所有状态
      this._handleResetAllStatus();
      return Promise.reject(error);
    }
  };

  /**
   * 停止本地录制
   */
  public stop = async () => {
    try {
      await ScreenShareApis.stopLocalRecord();
      this._handleResetAllStatus();
    } catch (error) {
      console.log("stop local error", error);
    }
  };

  /**
   * 暂停录制
   */
  public pause = () => {
    if (this._recording) {
      this._recording = false;
    }
  };

  /**
   * 继续录制
   */
  public continue = () => {
    this._recording = true;
  };

  /**
   * 切换设备
   * @param info
   */
  public switchMicrophone = async (info: StartAudioMixRecordConfig) => {
    const preConfig = this._currentConfig;
    try {
      await this.stop();
      await this.start(info);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      console.log("切换本地麦克风失败，重新连接上个本地麦克风");
      console.log("要切换的本地麦克风", info);
      this.start(preConfig!).catch((error) => {
        this._handleError(error);
      });
      return Promise.reject(error?.message || "切换本地麦克风失败");
    }
  };

  private _handleRecordData = (data: { data: number[] }) => {
    if (!this._recording) return;
    this.emit("data", data.data);
  };

  private _handleRecordStatus = (event: NotifyEvent<RecordStatus>) => {
    const { status } = event.data;
    if (status === "error") {
      this._handleError(new Error("收到录制状态错误"));
    }
  };

  private _handleResetAllStatus = () => {
    this._recordStatusUnsubscribe?.();
    this._recordDataUnsubscribe?.();
    this._currentConfig = null;
    this._recordStatusUnsubscribe = null;
    this._recordDataUnsubscribe = null;
  };

  private _handleError = (error: unknown) => {
    console.log("screen share _handleError", error);
    this.emit("error", error);
  };
}
